<template>
<div id="app">
    <v-app id="inspire" light>
        <v-card flat>
            <v-layout row wrap>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>Destek Talepleri</v-toolbar-title>
                </v-toolbar>
                <v-container fluid="">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md6>
                            <v-layout row wrap align-center="" justify-center="" fill-height="">
                                <v-flex xs12 sm4 md4>
                                    <tarihim :etiket="'Alış Tarihi'" :detaygizle="false" v-model="Destek.BaslangicTarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                </v-flex>
                                <v-flex xs12 sm4 md5>
                                    <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="Destek.BitisTarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                </v-flex>
                                <v-flex xs12 sm4 md2>
                                    <v-layout>
                                        <div>
                                            <v-btn color="info" fab small="" dark>
                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-btn small=""  color="info" fab dark>
                                            <v-icon>filter_list</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                                <v-layout row wrap align-center="" justify-center="">
                                    <v-flex xs12 sm12 md11>
                                        <v-form ref="musteriaraform" lazy-validation>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm11 md11>
                                                    <v-autocomplete hide-details="" :items="musteriitems" v-model="sorunVeri.MusteriKod" item-text="Title" item-value="MusteriID" clearable label="Müşteri Ara"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm1 md1>
                                                    <v-btn @click="musteriIDgonder(sorunVeri.MusteriKod)" color="info" fab small="" dark>
                                                        <v-icon>add</v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-form>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <v-card color="#1E88E5">
                                <v-layout>
                                    <v-flex xs2 sm2 md2>
                                        <v-layout align-center="" justify-center="" fill-height="">
                                            <v-icon color="white" large="">person</v-icon>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-card-title primary-title="">
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md4>
                                                        <v-list-tile-content>
                                                            <span class="subheading font-weight-bold white--text">
                                                                Bekleyen Sorunlarınız
                                                            </span>
                                                        </v-list-tile-content>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md8>
                                                        <v-list-tile-action>
                                                            <div class="font-weight-bold subheading  white--text  mb-1" @click="BekleyenSorunlar()"> :{{bekleyenitems.length}}</div>
                                                        </v-list-tile-action>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout row wrap>

                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md4>
                                                                <v-list-tile-content>
                                                                    <div class="font-weight-bold subheading  white--text  mb-1">Kullanıcı Adı</div>
                                                                </v-list-tile-content>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md8>
                                                                <v-list-tile-action>
                                                                    <div class="font-weight-bold subheading  white--text  mb-1">: {{KullaniciAdi}}</div>
                                                                </v-list-tile-action>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md4>
                                                                <v-list-tile-content>
                                                                    <div class="font-weight-bold subheading  white--text  mb-1">Günlük Şifre</div>
                                                                </v-list-tile-content>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md8>
                                                                <v-list-tile-action>
                                                                    <div class="font-weight-bold subheading  white--text  mb-1">:</div>
                                                                </v-list-tile-action>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md4>
                                                                <v-list-tile-content>
                                                                    <span class="subheading font-weight-bold white--text">
                                                                        Telefon Bekliyor
                                                                    </span>
                                                                </v-list-tile-content>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md8>
                                                                <v-list-tile-action>
                                                                    <div class="font-weight-bold subheading mb-1 red--text" @click="telefonBekliyorCekSayi()" color="red">:{{telefonitems.length}}</div>
                                                                </v-list-tile-action>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md4>
                                                                <v-list-tile-content>
                                                                    <span class="subheading font-weight-bold white--text" @click="TelefonAc()">
                                                                        Telefon Girişi
                                                                    </span>
                                                                </v-list-tile-content>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-title>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-layout row="" wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card>
                            <v-flex pa-2 xs12 sm12 md12>
                                <v-list two-line>
                                    <template v-for="item in sorunitems">
                                        <v-hover  v-bind:key="item.SorunID" v-slot:default="{ hover }">
                                            <v-card :elevation="hover ? 12 : 1">
                                                <v-layout ma-2 row wrap >
                                                    <v-flex xs6 sm4 md2>
                                                        <v-layout align-start="" justify-start fill-height>
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold caption ">
                                                                                Ticket No: {{item.SorunID}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold  caption">
                                                                                Müşteri Adı:{{item.MusteriBilgi.MusteriAdi}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs6 sm4 md3>
                                                        <v-layout align-start="" justify-start fill-height>
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content style="'overflow=inherit';">

                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold  caption">
                                                                                Arayan:{{item.Arayan}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold  caption">
                                                                                Sorun Tip: {{item.SorunTip.Aciklama}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs6 sm3 md3>
                                                        <v-layout align-start="" justify-start fill-height>
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold caption ">
                                                                                Alış Tarihi: {{item.AlisTarihi | dateformat}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>
                                                                            <div class="font-weight-bold  caption">
                                                                                Çözecek:{{item.CozecekBilgi.AdSoyad}}
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs10 sm8 md3>
                                                        <v-layout align-start="" justify-start fill-height>
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout>
                                                                                <div class="font-weight-bold caption">
                                                                                    Sorun:
                                                                                </div>
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>
                                                                            <div v-html="item.SorunAciklama.substring(0,70)" class="font-weight caption ">
                                                                            </div>
                                                                        </v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs2 sm4 md1>
                                                        <v-layout align-end="" justify-center="" fill-height="">
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content>
                                                                        <v-layout>
                                                                            <v-flex xs12 sm4 md5>
                                                                                <v-layout>
                                                                                    <v-btn small icon class="mx-0" @click="idgonder(item.SorunID)">
                                                                                        <v-icon color="info">edit</v-icon>
                                                                                    </v-btn>
                                                                                </v-layout>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                                <v-spacer :key="item.id"></v-spacer>
                                            </v-card>
                                        </v-hover>
                                    </template>
                                </v-list>
                            </v-flex>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-container>
                    <v-layout justify-center="">
                        <template v-if="vmodelpagination">
                            <div class="text-xs-center">
                                <v-container>
                                    <v-layout justify-center>
                                        <v-flex xs8>
                                            <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>
                        </template>
                    </v-layout>
                </v-container>
                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
            </v-layout>
        </v-card>
    </v-app>
    <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-2">
            <v-card-title>Filtre Seçimi</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" :items="itemshizmet" color="grey darken-1" v-model="Destek.HizmetTuru" item-text="text" item-value="value" label="Hizmet Türü"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" :items="itemsdurum" color="grey darken-1" v-model="Destek.CozulduMu" item-text="text" item-value="value" label="Durum"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" :items="itemskisit" color="grey darken-1" v-model="Kisit.deger" item-text="text" item-value="value" label="Kısıt"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" clearable="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" color="grey darken-1" v-model="Destek.Cozecek" label="Kullanıcı Adı">
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click="sorunCek()">Filtrelerİ Uygula</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="telefonEkle" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-2">
            <v-toolbar dark color="info">
                <v-toolbar-title>Telefon Bekliyor Ekle</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex xs12 sm4 md12>
                        <v-text-field v-model="SorunEkle.Arayan" label="Arayan">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-autocomplete v-model="SorunEkle.CozecekBilgi.UserID" label="Kullanıcı" item-text="KullaniciAd" item-value="Ref" hide-details="" :items="userlist" clearable="" color="grey darken-1">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <vue-editor v-model="SorunEkle.SorunAciklama" placeholder="Açıklama"></vue-editor>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="telefonEkle=false">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click="telefonGiris()">Ekle</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import auth from '../../../api/auth'
import helpers from "@/components/app/customcomp/helpers.js"
import tarihim from '../customcomp/tarihim'
import {
    VueEditor
} from "vue2-editor"

export default {
    data() {
        return {
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            loading: false,
            load1: true,
            secilenkayitlar: [],
            bekleyenitems: [],
            telefonitems: [],
            userlist: [],
            sayfalama: 1,
            pagenumber: 1,
            kayitadet: 50,
            kayitsayisi: 0,
            siralamatipi: 'InvoiceDate',
            sorunitems: [],
            itemsUserBilgi: [],
            telefonEkle: false,
            vmodelpagination: false,
            dialogfiltre: false,
            aramayapildimi: false,
            search: '',
            KullaniciAdi: '',
            itemshizmet: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Sözleşmeli',
                    value: '0'
                }, {
                    text: 'Ücretli',
                    value: '1'
                },
            ],
            itemskisit: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Firmaya Göre',
                    value: '0'
                },
                {
                    text: 'Kullanıcıya Göre',
                    value: '1'
                },
            ],
            itemsdurum: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Çözülmedi',
                    value: '0'
                }, {
                    text: 'Çözüldü',
                    value: '1'
                },
            ],
            Kisit: {
                deger: null,
            },
            musteriitems: [],
            sorunVeri: {
                MusteriKod: null,
                Cozecek: null,
            },
            Destek: {
                MusteriID: null,
                UserID: null,
                BaslangicTarih: null,
                BitisTarih: null,
                Cozuldu: null,
                UcretliDestek: null,
                Paging: {
                    SayfaNo: 1,
                    VeriAdet: 50,
                }
            },
            SorunEkle: {
                SorunID: null,
                MusteriBilgi: {
                    MusteriID: 665,
                    MusteriKod: null,
                    MusteriAdi: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                AlisTarihi: null,
                Arayan: null,
                ArayanMail: null,
                CozecekBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                Cozuldu: 0,
                UrunBilgi: {
                    Ref: null,
                    UrunAdi: null,
                    UrunAciklama: null,
                    Aciklama: null,
                },
                SorunAciklama: null,
                SorunTip: {
                    SorunTipID: 6,
                    Aciklama: null,
                },
                BaslangicSaat: null,
                BitisSaat: null,
                BeklenenYer: {
                    Id: null,
                    ParentId: null,
                    Aciklama: null,
                    Yetki: null,
                },
                UcretliDestek: null,
                UcretliDestekAciklama: null,
            },
        }
    },
    beforeMount: beforeMount,
    mounted() {},
    components: {
        tarihim,
        VueEditor
    },
    watch: {
        'kayitadet': function (valueveriadet) {
            this.sorunCek(1, valueveriadet, false)
        },
        'sayfalama': function (sayfa) {
            this.sorunCek(sayfa, this.kayitadet, false)
        },
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    },
    methods: {
        idgonder(e) {
            var url = '#/destek/sorundetay/id?' + 'sorunid=' + e + '&islem=guncelle'
            window.open(url, '_blank')
        },
        musteriIDgonder(a) {
            if (this.sorunVeri.MusteriKod == null) {
                this.text1 = 'Lütfen Müşteri Seçin'
                this.snackbar = true
                musteriIDgonder.stop()
            } else {
                var url = '#/destek/sorunislem/id?' + 'musterikod=' + a + '&islem=yeni'
                window.open(url, '_blank')
            }
        },
        sorunCek: sorunCek,
        musteriCek: musteriCek,
        filtrele: filtrele,
        userBilgileri: userBilgileri,
        telefonBekliyorCek: telefonBekliyorCek,
        telefonBekliyorCekSayi: telefonBekliyorCekSayi,
        BekleyenSorunlar: BekleyenSorunlar,
        BekleyenSorunlarSayi: BekleyenSorunlarSayi,
        telefonGiris: telefonGiris,
        userCek: userCek,
        TelefonAc: TelefonAc,
    },
}

function TelefonAc() {
    this.telefonEkle = true
    this.userCek()

}

function userCek() {
    this.$http.post(auth.API_URL + 'api/CalendarNew/UserList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.userlist = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-'
            this.snackbar = true
        }
    })
}

function telefonGiris() {

    var params = this.SorunEkle
    this.SorunEkle.AlisTarihi = this.Destek.BitisTarih,
        this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.telefonEkle = false
        }, (response) => {
            if (response.Status === true) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
            } else {
                this.text1 = response.statusText
                this.snackbar = true
            }
        })

}

function BekleyenSorunlar() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {
        BaslangicTarih: '2018-01-01',
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
        UserID: response.UserId
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.sorunitems = response.body
        this.bekleyenitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })

    this.dialogfiltre = false
}

function BekleyenSorunlarSayi() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {
        BaslangicTarih: '2018-01-01',
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
        UserID: response.UserId
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.bekleyenitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}

function userBilgileri() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {

        Email: response.Email
    }
    this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsUserBilgi = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function filtrele() {
    this.dialogfiltre = true
}

function telefonBekliyorCekSayi() {
    var params = {
        MusteriID: 665,
        BaslangicTarih: this.Destek.BaslangicTarih,
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {

    }).then((response) => {
        this.sorunitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}

function telefonBekliyorCek() {
    var params = {
           MusteriID: 665,
        BaslangicTarih: this.Destek.BaslangicTarih,
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {

    }).then((response) => {
        this.telefonitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}

function sorunCek(sayfanoo, kayitadett, aramayapildimi) {
    this.load1 = false

    if (aramayapildimi == true) {
        this.Destek.BaslangicTarih = this.Destek.BaslangicTarih
        this.Destek.BitisTarih = this.Destek.BitisTarih
        // this.Destek.Paging.VeriAdet = 50
        // this.Destek.Paging.SayfaNo = 1
    } else {
        //  this.Destek.Paging.VeriAdet = kayitadett
        // this.Destek.Paging.SayfaNo = sayfanoo
    }
    if (this.Kisit.deger == 1) {
        var response = JSON.parse(window.localStorage.getItem('response'))
        var params = {
            MusteriID: null,
            UserID: response.UserId,
            BaslangicTarih: this.Destek.BaslangicTarih,
            BitisTarih: this.Destek.BitisTarih,
            Cozuldu: this.Destek.CozulduMu,
            UcretliDestek: this.Destek.HizmetTuru,

        }
    } else if (this.Kisit.deger == 0) {
        var params = {
            MusteriID: null,
            UserID: this.Destek.Cozecek,
            BaslangicTarih: this.Destek.BaslangicTarih,
            BitisTarih: this.Destek.BitisTarih,
            Cozuldu: this.Destek.CozulduMu,
            UcretliDestek: this.Destek.HizmetTuru,
        }
    } else {
        var params = {
            MusteriID: null,
            UserID: this.Destek.Cozecek,
            BaslangicTarih: this.Destek.BaslangicTarih,
            BitisTarih: this.Destek.BitisTarih,
            Cozuldu: this.Destek.CozulduMu,
            UcretliDestek: this.Destek.HizmetTuru,
            // SayfaNo:this.Destek.Paging.SayfaNo,
            //VeriAdet:this.Destek.Paging.VeriAdet,
        }
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {

    }).then((response) => {
        this.sorunitems = response.body
        this.load1 = true
        /*
      if (response.body.sorunitems.length > 0) {
            this.kayitvarmi = true;
            this.pagenumber = response.body.TotalPage;
            this.vmodelpagination = true;
      }
      else {
            this.aramayapildi = false;
            this.kayitvarmi = false;
            this.load1 = true
            this.vmodelpagination = false;
            this.text1 = 'Kayıt Bulunamadı....'
            this.snackbar = true
          }*/

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}

function musteriCek() {
    this.$http.post(auth.API_URL + 'api/Awed/CustomerAllList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.musteriitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
}

function beforeMount() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    this.KullaniciAdi = response.AdSoyad
    this.musteriCek()
    this.Destek.BaslangicTarih = helpers.getDateNow()
    this.Destek.BitisTarih = helpers.getDateNow()
    this.sorunCek()
    this.musteriCek()
    this.userBilgileri()
    this.BekleyenSorunlarSayi()
    this.telefonBekliyorCek()
}
</script>

<style>
</style>
